import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "./Container";

import { PasswordInput, LabelWithColor, ReportTextTwo, ReportTextOne } from "../molecules";
import { Preloader } from "react-materialize";
import { Button, Loading } from "../atoms";
import { ReportController } from "../controllers";
import { MaterialIcon } from "../atoms/lib/MaterialIcon";
import { SimpleReport } from "../components";

import { MenagementReport } from "../models/lib/entities/MenagementReport";
import { MensurationReport } from "../models/lib/entities/MensurationReport";
import { ComunicationReport } from "../models/lib/entities/ComunicationReport";

class Report extends Container {
	constructor(props) {
		super(props);
		this.state = {
			values: {
				password: "",
				confirmPassword: "",
				oldPassword: "",

			},
			menagement: new MenagementReport(),
			mensuration: new MensurationReport(),
			comunication: new ComunicationReport(),
			general: {
				active: false,
				labels: [],
				colors: []
			},
			all: [],
			generalReport: {
				labels: [],
				points: [],
				colors: []
			},
			errors: {},
			reportUrl: null
		};
		this.controller = new ReportController(this);
	}
	componentWillMount() {
	}

	async componentDidMount() {
		const auth = this.copyRecursive(this.props.auth);
		if(!auth.done.menagement || !auth.done.mensuration || !auth.done.comunication) {
			this.props.router.push("/dashboard");
			return Materialize.toast("Termine de responder todos os formularios, para acessar o relatório.", 4000);
		}
		const state = this.getState();
		
		const menagement 	= await this.controller.generateMenagementChart();
		const comunication 	= await this.controller.generateComunicationChart();
		const mensuration 	= await this.controller.generateMensurationChart();

		const general = await this.controller.generateGeralChart(menagement, comunication, mensuration);

		state.menagement 	= menagement;
		state.mensuration	= mensuration;
		state.comunication	= comunication;
		state.generalReport = general;

		state.all = menagement.labels.concat(mensuration.labels.concat(comunication.labels));
		
		this.callback(state);
		$('.collapsible').collapsible();


		this.controller.renderPDF();
	}
	
	componentDidUpdate() {
		$('.collapsible').collapsible();
	}
	

	async componentWillReceiveProps(nextProps) {
		const state = this.getState();
		
		const menagement = await this.controller.generateMenagementChart();
		const comunication = await this.controller.generateComunicationChart();
		const mensuration = await this.controller.generateMensurationChart();
		
		const generalReport = await this.controller.generateGeralChart(menagement, comunication, mensuration);
		
		state.menagement = menagement;
		state.mensuration = mensuration;
		state.comunication = comunication;
		state.generalReport = generalReport;
		
		state.all = menagement.labels.concat(mensuration.labels.concat(comunication.labels));

		this.callback(state);
	}	

	renderItems(items, horizontal) {
		return items.labels.map((item, i) =>
			<LabelWithColor horizontal={false} key={i} label={items.labels[i]} style={{ backgroundColor: items.colors[i] }} />
		);
	}

	renderMask(id, labels) {
		if(typeof document !== "undefined") {
			const header = document.getElementsByClassName("collapsible-header")[0];
			const container = document.getElementById(id + "-container");
			
			if(header) {
				const angleInc = 2 * Math.PI / ( 2 * labels.length);
				let angle = angleInc;
				const radius = Math.floor((header.clientWidth - 60) / 4);
				const center = {
					x: 2 * radius,
					y: radius
				};

				const masks = [];
				for(let i in labels) {
					const label = labels[i];
					const style = {};
					let x = center.x + Math.sin(angle) * radius;
					let y = center.y + Math.cos(angle) * radius;

					if(angle > Math.PI && angle < 2 * Math.PI) {
						style.textAlign = "right";
						x -= 200;
					} 
					else if(angle > Math.PI * 0.9 && angle < Math.PI * 1.1) {
						x -= 100;
						style.textAlign = "center";
					} 

					if(y < radius) {
						y -= 30;
					}

					style.left = x + "px";
					style.bottom = y + "px";

					masks.push(<div className="label" style={style}>{label}</div>);
					angle += 2 * angleInc;
				}

				if(id == "general") {

					masks.push(this.renderLines(center, radius));

					const dimen = radius * 0.4;
					const circleStyle = {
						height: dimen + "px",
						width: dimen + "px",
						backgroundImage: "url(/assets/images/faucet.svg)"
					};
					masks.push(<div style={circleStyle} className="circle"/>);
				}
				return masks;
			}
		}
	}

	renderLines(center, radius) {
		const N_SLICES = 16;
		const lines = [];
		let lineAngle = 5 / N_SLICES * 360 - 90;
		let lineWidth = radius * 1.5;
		let xOffset = (1 - Math.cos(Math.radians(lineAngle))) * lineWidth / 2;
		let yOffset = Math.sin(Math.radians(lineAngle)) * lineWidth / 2;

		let lineStyle = {
			width: lineWidth + "px",
			bottom: center.y,
			left: center.x,
			transform: `rotate(${lineAngle}deg) translate(${xOffset}px, ${yOffset}px)`
		};
		lines.push(
			<div style={lineStyle} className="mask-line right">
				<div>Gestão</div>
				<div className="line"/>
			</div>
		);

		lineAngle = 11 / N_SLICES * 360 - 270;
		xOffset = (Math.cos(Math.radians(lineAngle)) - 1) * lineWidth / 2;
		yOffset = -Math.sin(Math.radians(lineAngle)) * lineWidth / 2;

		lineStyle = {
			width: lineWidth + "px",
			bottom: center.y - 16 + "px",
			left: center.x - lineWidth + "px",
			transform: `rotate(${lineAngle}deg) translate(${xOffset}px, ${yOffset}px)`
		};

		lines.push(
			<div style={lineStyle} className="mask-line left">
				<div className="line"/>
				<div>Mensuração</div>
			</div>
		);

		lineAngle = -90;
		xOffset = (1 - Math.cos(Math.radians(lineAngle))) * lineWidth / 2;
		yOffset = Math.sin(Math.radians(lineAngle)) * lineWidth / 2;

		lineStyle = {
			width: lineWidth + "px",
			bottom: center.y + "px",
			left: center.x - 8 + "px",
			transform: `rotate(${lineAngle}deg) translate(${xOffset}px, ${yOffset}px)`
		};

		lines.push(
			<div style={lineStyle} className="mask-line right">
				<div>Comunicação</div>
				<div className="line"/>
			</div>
		);
		return lines;
	}

	render() {
		const legend = {
			labels: [
				"Prática líder de mercado, excelência em gestão",
				"Estágio Avançado",
				"Passos iniciais, oportunidades de melhoria",
				"Nenhuma ação"
			],
			colors: [
				"rgba(000, 177, 112, .7)",
				"rgba(155, 206, 113, .7)",
				"rgba(224, 232, 124, .7)",
				"rgba(208, 002, 027, .7)"
			]
		};

		const { reportUrl } = this.state;

		return (
			<section className="reports">
				<div className="header">
					<h1>Relatório</h1>
				</div>
				{reportUrl ? null : <div className="loading-report">
					<div className="-text">Gerando relatório... Esta ação pode demorar alguns segundos.</div>
					<Preloader size="big"/>
				</div>}
				<div id="myPDF" calssName="myPDF" />
			</section>
		);
	}
}

const map = state => {
	return {
		auth: state.auth.model
	};
};

export default connect(map, null)(Report);


// WEBPACK FOOTER //
// src/containers/Report.js